import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * The transcript of an existing conversation, for surfaces that JOIN one rather
 * than own it (the compound and compare screens).
 *
 * Without this they mount ChatContainer on a live session but render the
 * generic welcome message — so the agent answers with everything it knows about
 * the client while the screen greets them as a stranger. The session is shared;
 * what's on screen has to match it.
 */
export default function useSessionTranscript(sessionId) {
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setMessages(null);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/api/history/sessions/${sessionId}`);
        if (!cancelled) setMessages(data.messages || []);
      } catch (err) {
        // A missing transcript is not fatal — the conversation still continues
        // server-side; the user just starts this screen with a clean view.
        console.error('Failed to load conversation transcript', err);
      }
    })();
    return () => { cancelled = true; };
  }, [sessionId]);

  return messages;
}
